import { FC, useState } from 'react'
import { isFulfilled } from '@reduxjs/toolkit'
import { push } from 'connected-react-router'

import CustomPopup from '../../UI/Popup'
import CustomButton from '../../UI/Buttons/CustomButton'
import Checkbox from '../../UI/Inputs/Checkbox'
import SocialToggler from '../../ToggleSocials'

import { selectSocialMediaDataBySocialName } from '../../../selectors/ProjectSelector'

import { useDispatch, useSelector } from '../../../store'
import {
  toggleChoosePostTypeAction,
  toggleIsAddingPostAction
} from '../../../store/application/slice'
import { setSelectedSocialsAction } from '../../../store/managePost/slice'
import { getAllowedSocialTypesThunk } from '../../../store/managePost/thunks'

import { SOCIAL_NETWORK } from '../../../models/post'

import { generatePath } from 'react-router'
import { AUTH_ROUTE } from '../../../pages/App/routes'
import './AddPostModal.scss'

const AddPostModal: FC<any> = () => {
  const dispatch = useDispatch()

  const { isOpenAddPost, socials, isGettingPostTypes, socialDetails, project } = useSelector((state) => ({
    socials: state.project.availableSocialNetworks,
    isOpenAddPost: state.app.isOpenAddPost,
    isGettingPostTypes: state.managePost.loaders.post.loadingTypes,
    project: state.project.currentProject,
    socialDetails: selectSocialMediaDataBySocialName(state)
  }))

  // TODO when available api
  const [activeSocial, setActiveSocial] = useState<SOCIAL_NETWORK>(socials[0])
  const [selectedSocials, setSelectedSocials] = useState<SOCIAL_NETWORK[]>([])

  const close = () => {
    dispatch(toggleIsAddingPostAction())
    setSelectedSocials([])
  }

  const startSchedulePost = async () => {
    const responsegetAllowedSocialTypes = await dispatch(
      getAllowedSocialTypesThunk({ social_networks: selectedSocials })
    )

    if (isFulfilled(responsegetAllowedSocialTypes)) {
      close()
      dispatch(setSelectedSocialsAction(selectedSocials))
      dispatch(toggleChoosePostTypeAction())
    }
  }

  const setAccountToPost = (social: SOCIAL_NETWORK) => {
    isChecked(social)
      ? setSelectedSocials((prev) => prev.filter((selectedSocial) => selectedSocial !== social))
      : setSelectedSocials((prev) => [...prev, social])
  }

  const isChecked = (social: SOCIAL_NETWORK) =>
    selectedSocials.some((selectedSocial) => selectedSocial === social)
  
  const moveToSocialAccountsPage = () => {
    dispatch(
      push(
        generatePath(AUTH_ROUTE.SOCIAL_ACCOUNTS, {
          projectId: project.id as number
        })
      )      
    )
    dispatch(toggleIsAddingPostAction())
  }

  return (
    <CustomPopup
      open={isOpenAddPost}
      buttonClose={close}
      closeOnDocumentClick={false}
      className='add-post'
    >
      <div className='add-post__wrapper'>
      <div className='add-post__header'>{socials.length ? "Add Post" : "Account error"}</div>
        {socials.length ? (
          <>
            <div className='add-post__tooltip'>Select profile(s)</div>
            <SocialToggler {...{ socials, activeSocial, setActiveSocial, isChecked }}>
              {socials.map((social: SOCIAL_NETWORK) => {
                // TODO label1 when socials will be available
                if (activeSocial === social) {
                  return (
                    <div key={`connected-account-${social}`} className='add-post__accounts'>
                      <div className='account'>
                        <div className='account__user-info'>
                          {socialDetails[social].logo.original ? (
                            <img
                              className='account__user-info__icon'
                              alt='avatar'
                              src={socialDetails[social].logo.original}
                            />
                          ) : (
                            socialDetails[social].logo.default
                          )}
                          {/* <div className='account__user-info__avatar-placeholder'></div> */}
                          <div className='account__user-info__name'>
                            {socialDetails[social]!.name}
                          </div>
                        </div>
                        <Checkbox
                          type='checkbox'
                          checked={isChecked(social)}
                          onChange={() => setAccountToPost(social)}
                        />
                      </div>
                    </div>
                  )
                }
              })}
            </SocialToggler>
            <div className='add-post__actions'>
              <CustomButton onClick={close} button='secondary'>
                No
              </CustomButton>
              <CustomButton
                disabled={!selectedSocials.length}
                inProgress={isGettingPostTypes}
                onClick={startSchedulePost}
                button='primary'
              >
                Yes
              </CustomButton>
            </div>
          </>
        ) : (
          <div className='add-post__tooltip'>
            <span>Something went wrong, please verify your social media settings or contact administrator, please check the social media accounts below!.</span>
            <button className="button__primary settings__button" onClick={moveToSocialAccountsPage}>Go to settings</button>
          </div>
        )}
      </div>
    </CustomPopup>
  )
}

export default AddPostModal
